import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { MessageSquare } from 'lucide-react';
import { SupportOptionsModal } from './SupportOptionsModal';

export function FloatingSupportButton() {
  const [showSupportOptions, setShowSupportOptions] = useState(false);

  return (
    <>
      {/* Floating Support Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <Button
          onClick={() => setShowSupportOptions(true)}
          className="h-14 w-14 rounded-full bg-blue-600 hover:bg-blue-700 shadow-lg hover:shadow-xl transition-all duration-300 group"
          size="icon"
        >
          <MessageSquare className="h-6 w-6 group-hover:scale-110 transition-transform" />
          <span className="sr-only">Open Support</span>
        </Button>
        
        {/* Tooltip */}
        <div className="absolute bottom-16 right-0 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
          Need Help?
        </div>
      </div>

      {/* Support Options Modal */}
      <SupportOptionsModal 
        open={showSupportOptions} 
        onOpenChange={setShowSupportOptions} 
      />
    </>
  );
}
